import { gql } from '@apollo/client';

export const GET_TRENDING_RECOMMENDATIONS = gql`
  query GetTrendingRecommendations($sourceUrl: String!, $countryCode: String!) {
    getTrendingRecommendations(sourceUrl: $sourceUrl, countryCode: $countryCode) {
      id
      sourceUrl
      candidates {
        href
        title
        reason
        similarity
      }
      widgetHtml
      updatedAt
    }
  }
`;

export interface TrendingCandidate {
  href: string;
  title: string;
  reason: string;
  similarity: number;
}

export interface TrendingRecommendationResponse {
  getTrendingRecommendations: {
    id: string;
    sourceUrl: string;
    candidates: TrendingCandidate[];
    widgetHtml: string;
    updatedAt: string;
  } | null;
}


